import { render, staticRenderFns } from "./SaveAndCancelButtons.vue?vue&type=template&id=2ecc303e&"
import script from "./SaveAndCancelButtons.vue?vue&type=script&lang=js&"
export * from "./SaveAndCancelButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports